$(document).ready(function($){

  $(".banner_slider .banner_list").slick({
    dots: true,
    infinite: true,
    arrows: false,
    autoplay:true,
    autoplaySpeed:3000,
    speed: 1500,
    slidesToShow: 1,
    adaptiveHeight: true,
  });

$('.reviews_bg .customer_list').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


$('.collection_slider_main .grid-uniform').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1360,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


$('.related-products-slider .related-products-list').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1360,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

});


// header search popup js

document.addEventListener("DOMContentLoaded", function() {
  const searchBtn = document.querySelector(".header_search_main");
  const popup = document.querySelector(".header_search_popup");
  const closeBtn = document.querySelector(".close_popup");

  searchBtn.addEventListener("click", function() {
    popup.classList.add("active");
    document.body.classList.add("no-scroll");
  });

  popup.addEventListener("click", function(e) {
    if (e.target === popup) {
      popup.classList.remove("active");
      document.body.classList.remove("no-scroll");
    }
  });

  closeBtn.addEventListener("click", function() {
    popup.classList.remove("active");
    document.body.classList.remove("no-scroll");
  });

  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape") {
      popup.classList.remove("active");
      document.body.classList.remove("no-scroll");
    }
  });
});